// Used by snippets/purolabs-stock-line.liquid
// Estimated delivery: dispatch today on a weekday before the cut-off (UK time), otherwise the next weekday, then the
// minimum and maximum delivery days in transit, which include Saturdays. Sundays and the closed days (Theme settings >
// Delivery estimate) never count. When the earliest day is a Saturday it names that day alone: those orders dispatch on
// a Thursday and 95% arrive on the Saturday (Oct 2026 Royal Mail deliveries), and the range would read as far longer
// than it is by spanning the Sunday.
class DeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const dates = this.querySelector('[data-dates]');
    if (!dates) return;
    const cutoff = Number(this.dataset.cutoff) || 14;
    const closed = new Set((this.dataset.closed || '').split(',').filter(Boolean));
    const now = Object.fromEntries(
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date())
        .map((part) => [part.type, part.value])
    );
    // London's calendar date held as midnight UTC, so stepping through days never meets a clock change
    const dispatch = new Date(Date.UTC(+now.year, +now.month - 1, +now.day));
    const isOpen = (date) => !closed.has(date.toISOString().slice(0, 10));
    const isDispatchDay = (date) => date.getUTCDay() % 6 !== 0 && isOpen(date);
    const isDeliveryDay = (date) => date.getUTCDay() !== 0 && isOpen(date);
    const next = (date, isDay) => {
      do date.setUTCDate(date.getUTCDate() + 1);
      while (!isDay(date));
      return date;
    };
    if (!isDispatchDay(dispatch) || +now.hour >= cutoff) next(dispatch, isDispatchDay);
    const [from, to] = [this.dataset.min, this.dataset.max].map((days) => {
      const date = new Date(dispatch);
      for (let i = 0; i < (Number(days) || 2); i++) next(date, isDeliveryDay);
      return date;
    });
    const ordinal = (date) => {
      const day = date.getUTCDate();
      const suffix = day % 10 === 1 && day !== 11 ? 'st' : day % 10 === 2 && day !== 12 ? 'nd' : day % 10 === 3 && day !== 13 ? 'rd' : 'th';
      return day + suffix;
    };
    const month = (date) => date.toLocaleDateString('en-GB', { timeZone: 'UTC', month: 'short' });
    // "Sat 7th Nov", "3rd Nov", "3rd–4th Nov" or "30th Oct – 2nd Nov"
    if (from.getUTCDay() === 6) dates.textContent = `Sat ${ordinal(from)} ${month(from)}`;
    else if (from.getTime() === to.getTime()) dates.textContent = `${ordinal(to)} ${month(to)}`;
    else if (from.getUTCMonth() === to.getUTCMonth()) dates.textContent = `${ordinal(from)}–${ordinal(to)} ${month(to)}`;
    else dates.textContent = `${ordinal(from)} ${month(from)} – ${ordinal(to)} ${month(to)}`;
  }
}

if (!customElements.get('pl-delivery-estimate')) customElements.define('pl-delivery-estimate', DeliveryEstimate);
